module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shippingDistanceError":"The requested distance is too great, we do not exceed 55 kilometers **"},"fr":{"shippingDistanceError":"La distance demandées est trop grande, nous ne dépassons pas 55 kilomètre **"}}')
  delete Component.options._Ctor
}
